var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLogout = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 23 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.415.507h11.2a1.92 1.92 0 011.87 1.811l.002.15v4.225a.974.974 0 01-.972.977c-.5 0-.909-.378-.965-.863l-.006-.114-.001-4.232H2.441l.002.007v17.077h11.1v-4.202c0-.5.375-.914.859-.971l.113-.007.114.007c.447.052.8.41.851.857l.007.114v4.225c0 1.015-.776 1.85-1.765 1.926l-.15.006H2.415a1.922 1.922 0 01-1.91-1.781L.5 19.568V2.439C.5 1.373 1.356.507 2.415.507z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.738 7.49l.088.083 3.287 3.457c.148.139.243.326.272.527l.01.122-.375.003.375.005a.912.912 0 01-.191.552l-.076.083-3.305 3.475a.838.838 0 01-1.143.063l-.093-.089a.904.904 0 01-.062-1.135l.074-.089 1.88-1.976H9.502a.868.868 0 01-.85-.777l-.006-.11c0-.449.322-.827.748-.882l.108-.007h8.98l-1.894-1.999a.904.904 0 01-.064-1.134l.078-.091a.834.834 0 011.137-.08z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_logout.12f0f7bb24dbd671604efb26ae17922f.svg";